import { render } from "./TrainingBlocStopSubscriptionButton.vue?vue&type=template&id=55a247cf"
import script from "./TrainingBlocStopSubscriptionButton.vue?vue&type=script&lang=js"
export * from "./TrainingBlocStopSubscriptionButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__